import { Button, Card, Col, Row, Statistic } from "antd";

const givingHighlights = [
  {
    title: "Trinity College Endowment Fund",
    amount: "Rs. 3 billion",
    subAmount: "$8,950,719 USD",
    description:
      "A historic endowment for scholarships, financial assistance, educational excellence, and the long-term sustainability of Trinity College Kandy.",
    href: "/#trinity-endowment-3-billion",
  },
  {
    title: "Little Hearts Project",
    amount: "Rs. 1 billion",
    subAmount: "$3,055,000 USD",
    description:
      "Support for Lady Ridgeway Hospital's pediatric cardiac and critical care initiative, helping children who need life-saving treatment.",
    href: "/#lady-ridgeway-hospital",
  },
  {
    title: "S. Thomas' College IT Complex",
    amount: "Rs. 600 million",
    subAmount: "$1,974,000 USD",
    description:
      "A state-of-the-art Information Technology building to equip students for the digital age.",
    href: "/#st-thomas-college",
  },
  {
    title: "Sunera Foundation",
    amount: "Rs. 400 million",
    description:
      "A major contribution supporting children with special needs through the Sunera Foundation.",
    href: "#additional-giving",
  },
  {
    title: "Bishop's College Roshanne Wijesuriya Building",
    amount: "Rs. 270 million",
    subAmount: "$892,441 USD",
    description:
      "A modern A-Level and O-Level building created in memory of Roshanne Wijesuriya.",
    href: "/#roshanne-wijesuriya-building",
  },
  {
    title: "Ananda College STEAM Initiative",
    amount: "Rs. 250 million",
    subAmount: "$820,580 USD",
    description:
      "Support for a Centre of Excellence advancing science, technology, engineering, arts, and mathematics education.",
    href: "/#ananda-college",
  },
  {
    title: "Nalanda Sports Arena",
    amount: "Rs. 100 million",
    subAmount: "$298,172 USD",
    description:
      "A landmark contribution towards the second phase of Nalanda College's Centenary Project.",
    href: "/#nalanda-sports-arena",
  },
  {
    title: "National Kidney Stone Referral Centre",
    amount: "Rs. 161 million",
    subAmount: "$492,000 USD",
    description:
      "The complete range of modern medical equipment for the newly established National Kidney Stone Referral Centre in Meerigama.",
    href: "/#a-landmark-gift-transforming-kidney-stone-care-in-sri-lanka",
  },
  {
    title: "Kollupitiya Market Renewal",
    amount: "Rs. 29 million",
    description:
      "A community-focused restoration and modernization project supporting vendors, shoppers, and the urban public realm.",
    href: "/#kollupitiya-market",
  },
  {
    title: "Trinity Badminton Complex",
    amount: "Rs. 100 million",
    description:
      "A Rs. 100 million contribution towards a dedicated badminton facility at Asgiriya Stadium, giving Trinity students a permanent home for training and competition.",
    href: "/#trinity-badminton",
  },
  {
    title: "Kandy Girls' High School",
    amount: "Rs. 100 million",
    description:
      "A swimming pool built in memory of his sister Maheswari, supporting students at Kandy Girls' High School.",
    href: "#additional-giving",
  },
  {
    title: "Scholarships Grants",
    amount: "Rs. 13 million per year, ongoing",
    description:
      "Since 2017, 54 low-income university students studying naval engineering have received Rs. 20,000 each month through the foundation established in memory of his mother.",
    href: "#additional-giving",
  },
  {
    title: "More",
    amount: "Rs. 102 million+",
    description:
      "Additional giving includes Rs. 50 million to the Sri Lanka Cancer Society, Rs. 27 million through Lanka Foundation, Rs. 25 million for a rural elderly home, support for remote schools and drinking water in Poonarin, Jaffna, support for the Old Trinitians Sports Club at Asgiriya around 1990, Sri Lanka's first bowling machine for Trinity College Kandy around 1995, and a fund to supplement Trinity's cricket coaches.",
    href: "#additional-giving",
  },
];

const linkList = [
  ["Lady Ridgeway Hospital", "/#lady-ridgeway-hospital"],
  ["Roshanne Wijesuriya Building", "/#roshanne-wijesuriya-building"],
  ["Kollupitiya Market", "/#kollupitiya-market"],
  ["St. Thomas' College", "/#st-thomas-college"],
  ["Ananda College", "/#ananda-college"],
  ["Trinity Badminton", "/#trinity-badminton"],
  ["Trinity Endowment 3 Billion", "/#trinity-endowment-3-billion"],
  ["Nalanda Sports Arena", "/#nalanda-sports-arena"],
  [
    "National Kidney Stone Referral Centre",
    "/#a-landmark-gift-transforming-kidney-stone-care-in-sri-lanka",
  ],
];

export const Giving = () => {
  return (
    <div
      style={{
        background: "#f7f4ee",
        minHeight: "100vh",
        padding: "32px 16px 56px",
      }}
    >
      <div style={{ maxWidth: "1180px", margin: "0 auto" }}>
        <section
          style={{
            background: "#ffffff",
            border: "1px solid #eadfce",
            padding: "40px 32px",
            marginBottom: "24px",
          }}
        >
          <p
            style={{
              color: "#8a5b25",
              fontSize: "13px",
              fontWeight: 700,
              letterSpacing: "0.08em",
              marginBottom: "10px",
              textTransform: "uppercase",
            }}
          >
            Giving
          </p>
          <h1 style={{ fontSize: "40px", lineHeight: 1.15, margin: 0 }}>
            A Legacy Beyond Wealth: Nahil Wijesuriya's Gift to Education,
            Healthcare and Children
          </h1>
          <p style={{ fontSize: "18px", lineHeight: 1.75, marginTop: "20px" }}>
            Sri Lanka has been blessed with many generous philanthropists, but
            few individuals have demonstrated a sustained commitment to
            healthcare, education and children's welfare on the scale witnessed
            in recent years from Engineer Nahil Wijesuriya.
          </p>
          <p style={{ fontSize: "18px", lineHeight: 1.75 }}>
            With the announcement of his historic Rs. 3 billion donation to
            establish the Trinity College Endowment Fund, Nahil Wijesuriya has
            once again demonstrated that true success is measured not by what
            one accumulates, but by what one gives back to society.
          </p>
          <Row gutter={[16, 16]} style={{ marginTop: "28px" }}>
            <Col xs={24} md={8}>
              <Statistic title="Publicly known giving" value="Rs. 6.1B+" />
              <p
                style={{
                  color: "#6f6a63",
                  fontSize: "13px",
                  margin: "2px 0 0",
                }}
              >
                Approx. $18.7 million USD
              </p>
            </Col>
            <Col xs={24} md={8}>
              <Statistic title="Major institutions" value={14} />
            </Col>
            <Col xs={24} md={8}>
              <Statistic title="Focus" value="Children and education" />
            </Col>
          </Row>
        </section>

        <section style={{ marginBottom: "24px" }}>
          <Row gutter={[16, 16]}>
            {givingHighlights.map((item) => (
              <Col xs={24} md={12} lg={8} key={item.title}>
                <Card
                  title={item.title}
                  style={{ height: "100%" }}
                  extra={
                    <a href={item.href} style={{ color: "#8a5b25" }}>
                      Read
                    </a>
                  }
                >
                  <p
                    style={{
                      color: "#1f1f1f",
                      fontSize: "20px",
                      fontWeight: 700,
                      marginBottom: "10px",
                    }}
                  >
                    {item.amount}
                  </p>
                  {item.subAmount && (
                    <p
                      style={{
                        color: "#6f6a63",
                        fontSize: "13px",
                        marginTop: "-6px",
                        marginBottom: "10px",
                      }}
                    >
                      {item.subAmount}
                    </p>
                  )}
                  <p style={{ lineHeight: 1.65, marginBottom: 0 }}>
                    {item.description}
                  </p>
                </Card>
              </Col>
            ))}
          </Row>
        </section>

        <section
          id="additional-giving"
          style={{
            background: "#ffffff",
            border: "1px solid #eadfce",
            padding: "32px",
            marginBottom: "24px",
          }}
        >
          <p style={{ fontSize: "17px", lineHeight: 1.75 }}>
            What makes this record particularly significant is that it is not an
            isolated act of generosity. It is a pattern of philanthropy that has
            touched schools, hospitals, community spaces, and thousands of young
            lives across Sri Lanka.
          </p>
          <p style={{ fontSize: "17px", lineHeight: 1.75 }}>
            Beyond the major school and hospital gifts, Eng. Nahil Wijesuriya
            FIMarEST has also supported the Sunera Foundation with Rs. 400
            million for children with special needs, Kandy Girls' High School
            with Rs. 100 million, the Sri Lanka Cancer Society with Rs. 50
            million, several remote schools in Poonarin, Jaffna, a drinking
            water project, Rs. 27 million through Lanka Foundation, and Rs. 25
            million for a rural elderly home.
          </p>
          <p style={{ fontSize: "17px", lineHeight: 1.75 }}>
            Through the Agnes Wijesuriya Charity Foundation, established in the
            name of his mother, 54 low-income university students studying naval
            engineering receive scholarships of Rs. 20,000 each month. This
            monthly commitment of approximately Rs. 1.1 million, or Rs. 13
            million each year, has been maintained continuously since 2017.
          </p>
          <p style={{ fontSize: "17px", lineHeight: 1.75 }}>
            His generosity has not been confined to one institution or one
            tradition. He has supported children in hospitals, students in
            Anglican schools, students in Buddhist schools, and young people
            from diverse backgrounds across the country. Whether Trinitian,
            Thomian, Bishopian, Anandian, Nalandian, or a child fighting for
            life at Lady Ridgeway Hospital, the beneficiaries are united by a
            single principle: opportunity.
          </p>
          <p style={{ fontSize: "17px", lineHeight: 1.75 }}>
            At a time when many speak about giving back, Nahil Wijesuriya has
            transformed gratitude into action. His donations are not simply
            gifts; they are investments in human potential. Every scholarship
            awarded, every classroom constructed, every technology centre
            established, every sports facility opened, and every child whose
            life is saved through improved healthcare becomes part of a legacy
            that will continue for generations.
          </p>
          <p style={{ fontSize: "17px", lineHeight: 1.75 }}>
            History often remembers great benefactors not for the wealth they
            possessed but for the lives they transformed. By that measure, Nahil
            Wijesuriya's contribution to Sri Lanka is already profound.
          </p>
          <p style={{ fontSize: "15px", marginBottom: 0 }}>
            Dr Duresh De Silva
          </p>
        </section>

        <section
          style={{
            background: "#2f2a24",
            color: "#ffffff",
            padding: "32px",
          }}
        >
          <h2 style={{ color: "#ffffff", marginTop: 0 }}>
            Charitable Contribution Chapters
          </h2>
          <Row gutter={[12, 12]}>
            {linkList.map(([label, href]) => (
              <Col xs={24} sm={12} lg={8} key={href}>
                <a href={href} style={{ display: "block" }}>
                  <Button block>{label}</Button>
                </a>
              </Col>
            ))}
          </Row>
        </section>
      </div>
    </div>
  );
};
